import { useEffect, useRef } from "react";
import videojs from "video.js";
// eslint-disable-next-line import/no-unresolved
import Player from "video.js/dist/types/player";
import "video.js/dist/video-js.css";

interface VideoJSSource {
  src: string;
  type: string;
}

// Video.js types are lacking,
// full list of options can be found here: https://videojs.com/guides/options/.
interface VideoJSProps {
  controls: boolean;
  autoplay: boolean;
  fluid: boolean;
  sources: VideoJSSource[];
}

export const VideoJS = (options: VideoJSProps) => {
  const videoRef = useRef<HTMLDivElement>(null);
  const playerRef = useRef<Player | null>(null);

  useEffect(() => {
    // Make sure Video.js player is only initialized once
    if (!playerRef.current) {
      const videoElement = document.createElement("video-js");

      videoElement.classList.add("vjs-big-play-centered");
      videoRef.current?.appendChild(videoElement);

      playerRef.current = videojs(videoElement, options, () => {
        videojs.log("player is ready");
      });

      // You could update an existing player in the `else` block here
      // on prop change, for example:
    } else {
      const player = playerRef.current;

      player.autoplay(options.autoplay);
      player.src(options.sources);
    }
  }, [options, videoRef]);

  // Dispose the Video.js player when the functional component unmounts
  useEffect(() => {
    const player = playerRef.current;

    return () => {
      if (player && !player.isDisposed()) {
        player.dispose();
        playerRef.current = null;
      }
    };
  }, [playerRef]);

  return (
    <div data-vjs-player>
      <div ref={videoRef} />
    </div>
  );
};
